import { render, staticRenderFns } from "./GiftPaywallFooter.vue?vue&type=template&id=29da4b8c&scoped=true&"
import script from "./GiftPaywallFooter.vue?vue&type=script&lang=ts&"
export * from "./GiftPaywallFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GiftPaywallFooter.vue?vue&type=style&index=0&id=29da4b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da4b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('29da4b8c', component.options)
    } else {
      api.reload('29da4b8c', component.options)
    }
    module.hot.accept("./GiftPaywallFooter.vue?vue&type=template&id=29da4b8c&scoped=true&", function () {
      api.rerender('29da4b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/gifts/paywall/GiftPaywallFooter.vue"
export default component.exports